import { AccountDetailsContext } from "core/cuenta/contexts/AccountDetailsContext";
import { useContext } from "react"
import { AccountMovementsTableWithPagination } from "../AccountMovementsTableWithPagination/AccountMovementsTableWithPagination";

export const AccountMovementsList = () => {
  const {
    movimientosCuenta,
  } = useContext(AccountDetailsContext);

  return (
    <>
      {!movimientosCuenta || (
        <AccountMovementsTableWithPagination
          movimientos={movimientosCuenta}
        ></AccountMovementsTableWithPagination>
      )}
    </>
  )
}